import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import Cart from './Cart';
import '../styles/Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { cart } = useCart();
  const [showCart, setShowCart] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0);

  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={handleLinkClick}>
            MD Sweets Caterers
          </Link>
          
          <div className="navbar-actions">
            <button 
              className="mobile-cart-icon" 
              onClick={() => setShowCart(true)}
              aria-label="Open cart"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="9" cy="21" r="1"/>
                <circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              {cartItemCount > 0 && <span className="cart-badge">{cartItemCount}</span>}
            </button>

            <button 
              className="hamburger-menu" 
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

          {menuOpen && <div className="menu-backdrop" onClick={() => setMenuOpen(false)} />}

          <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
            <li><Link to="/shop" onClick={handleLinkClick}>Shop</Link></li>
            <li><Link to="/custom-order" onClick={handleLinkClick}>Custom Order</Link></li>
            {user && (
              <>
                <li><Link to="/orders" onClick={handleLinkClick}>Orders</Link></li>
                <li><Link to="/my-custom-orders" onClick={handleLinkClick}>My Custom Orders</Link></li>
                <li><Link to="/profile" onClick={handleLinkClick}>Profile</Link></li>
                {user.role === 'admin' && (
                  <li><Link to="/admin" onClick={handleLinkClick}>Admin</Link></li>
                )}
              </>
            )}
            {user ? (
              <li><button onClick={() => { logout(); handleLinkClick(); }} className="btn-link">Logout</button></li>
            ) : (
              <li><Link to="/login" onClick={handleLinkClick}>Login</Link></li>
            )}
            <li>
              <button onClick={() => { setShowCart(true); handleLinkClick(); }} className="cart-btn">
                Cart ({cartItemCount})
              </button>
            </li>
          </ul>
        </div>
      </nav>
      {showCart && <Cart onClose={() => setShowCart(false)} />}
    </>
  );
};

export default Navbar;
